import React, { useState } from 'react';
import css from './SectionImpact.module.css';
import { FormattedMessage } from '../../util/reactIntl';

// Redesign taxonomy icons. Marine / Culture / Adventure are the new transparent
// teal line-art icons served from /public; Animal & Nature reuse the existing
// category illustrations.
const marineIcon = '/static/icons/categories/marine.png';
const animalIcon = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082365/socialbnb/assets/categories/animal.webp';
const natureIcon = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082367/socialbnb/assets/categories/environment.webp';
const cultureIcon = '/static/icons/categories/culture.png';
const adventureIcon = '/static/icons/categories/adventure.png';

// The five project categories shown around the impact circle. Order matches the
// `nth-of-type` positioning in SectionImpact.module.css.
const CATEGORIES = [
  {
    key: 'marine',
    icon: marineIcon,
    iconClass: css.marineIcon,
    headingId: 'about.marineIconH',
    textId: 'about.marineIconP',
  },
  {
    key: 'animal',
    icon: animalIcon,
    iconClass: css.animalIcon,
    headingId: 'about.animalIconH',
    textId: 'about.animalIconP',
  },
  {
    key: 'nature',
    icon: natureIcon,
    iconClass: css.environmentIcon,
    headingId: 'about.environmentIconH',
    textId: 'about.environmentIconP',
  },
  {
    key: 'culture',
    icon: cultureIcon,
    iconClass: css.cultureIcon,
    headingId: 'about.cultureIconH',
    textId: 'about.cultureIconP',
  },
  {
    key: 'adventure',
    icon: adventureIcon,
    iconClass: css.adventureIcon,
    headingId: 'about.adventureIconH',
    textId: 'about.adventureIconP',
  },
];

function SectionImpact() {
  // `active` holds the hovered/tapped category key, or null to show the intro text.
  const [active, setActive] = useState(null);
  const activeCategory = CATEGORIES.find(c => c.key === active) || null;

  return (
    <>
      <div
        className={css.impactWrapper}
        data-elb="section"
        data-elb-section="name:impactSection;position:7"
        data-elbaction="visible"
      >
        <h2 className={css.impactHeader}>
          <FormattedMessage id="about.impactHeadline" />
        </h2>
      </div>
      <div className={css.circleWrapper}>
        <div className={css.circle}>
          <ul
            className={css.circleContainer}
            onMouseLeave={() => setActive(null)}
          >
            {CATEGORIES.map(cat => (
              <li
                key={cat.key}
                className={cat.iconClass}
                onMouseEnter={() => setActive(cat.key)}
                onClick={() => setActive(cat.key)}
              >
                <img
                  src={cat.icon}
                  alt="socialbnb icons für Tourismus mit Wirkung/impact tourism"
                />
              </li>
            ))}
          </ul>
          <div className={css.text}>
            {activeCategory ? (
              <>
                <h3>
                  <FormattedMessage id={activeCategory.headingId} />
                </h3>
                <p>
                  <FormattedMessage id={activeCategory.textId} />
                </p>
              </>
            ) : (
              <>
                <h3>
                  <FormattedMessage id="about.mainCircleH" />
                </h3>
                <p>
                  <FormattedMessage id="about.mainCircleP" />
                </p>
              </>
            )}
          </div>

          <ul className={css.backgroundContainer}>
            {CATEGORIES.map(cat => (
              <li key={cat.key}>
                <div className={css.background} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default SectionImpact;
